import { render, staticRenderFns } from "./PaymentLMSG.vue?vue&type=template&id=1f3b274e&scoped=true&"
import script from "./PaymentLMSG.vue?vue&type=script&lang=js&"
export * from "./PaymentLMSG.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLMSG.vue?vue&type=style&index=0&id=1f3b274e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3b274e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3b274e')) {
      api.createRecord('1f3b274e', component.options)
    } else {
      api.reload('1f3b274e', component.options)
    }
    module.hot.accept("./PaymentLMSG.vue?vue&type=template&id=1f3b274e&scoped=true&", function () {
      api.rerender('1f3b274e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/components/PaymentLMSG.vue"
export default component.exports